<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OoajDH/tc-custom/9780226148533.jpg?1728259572482" alt="This image is the cover for the book Elephant Memories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Elephant Memories
      </h1>
      <p class="bookDescription body article font2">
        <b>“A style so conversational…that I felt like a privileged visitor riding beside her in her rickety Land-Rover as she showed me around the park." —<i>The New York Times Book Review</i></b><br/><br/> Cynthia Moss spent many years living in Kenya’s Amboseli National Park and studying the elephants there, and her long-term research has revealed much of what we now know about these complex and intelligent animals. In this book, she shares a more up-close and personal perspective, chronicling the lives of the elephant families led by matriarchs Teresia, Slit Ear, Torn Ear, Tania, and Tuskless, including a rare look at calves and their development. This edition is also updated with a new afterword, catching up on the families, covering current conservation issues, and “celebrating a species from which we could learn some moral as well as zoological lessons” (<i>Chicago Tribune</i>).<br/><br/> “One is soon swept away by this ‘Babar’ for adults. By the end, one even begins to feel an aversion for people. One wants to curse human civilization and cry out, ‘Now God stand up for the elephants!’”—<i>The New York Times</i><br/><br/> “Moss speaks to the general reader, with charm as well as scientific authority…[An] elegantly written and ingeniously structured account.”—<i>The</i><i>Wall Street Journal</i><br/>  <br/> “Any reader interested in animals will be captivated.”—<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cynthia Moss
      </h2>
      
      <p class="authorDescription body article">Cynthia F. Moss is a professor of psychology and member of the Institute for Systems Research at the University of Maryland, College Park. She is the coeditor of Neuroethological Studies on Cognitive and Perceptual Processes.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7ed2639e